import { observer } from 'mobx-react-lite';
import { ComponentProps, ReactElement } from 'react';

export const InfoIcon = observer(
  (props: ComponentProps<'svg'>): ReactElement => (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <g clipPath='url(#clip0_1126_1827)'>
        <path
          d='M9.99996 1.66699C5.39996 1.66699 1.66663 5.40033 1.66663 10.0003C1.66663 14.6003 5.39996 18.3337 9.99996 18.3337C14.6 18.3337 18.3333 14.6003 18.3333 10.0003C18.3333 5.40033 14.6 1.66699 9.99996 1.66699ZM9.99996 14.167C9.54163 14.167 9.16663 13.792 9.16663 13.3337V10.0003C9.16663 9.54199 9.54163 9.16699 9.99996 9.16699C10.4583 9.16699 10.8333 9.54199 10.8333 10.0003V13.3337C10.8333 13.792 10.4583 14.167 9.99996 14.167ZM10.8333 7.50033H9.16663V5.83366H10.8333V7.50033Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_1126_1827'>
          <rect
            width='20'
            height='20'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
);
